/** 회사 소개 "What we do" 의 가치 한 줄 — 서비스 개요(CLAUDE.md)의 사실만 옮긴다. */
export interface ValuePoint {
  readonly title: string;
  readonly description: string;
}

export const VALUE_POINTS: readonly ValuePoint[] = [
  {
    title: '직접 디자인하는 에디터',
    description: '상품 사진 위에서 직접 디자인하고, 완성될 모습을 바로 확인합니다.',
  },
  {
    title: '수량별 투명한 가격',
    description: '수량 구간별 단가를 미리 공개해, 디자인하면서 임시 견적을 확인할 수 있습니다.',
  },
  {
    title: '상담 후 확정견적',
    description: '상담을 요청하면 운영자가 디자인과 수량을 검토해 확정견적을 보내 드립니다.',
  },
  {
    title: '주문 후 생산',
    description:
      '재고를 쌓아 두지 않고 주문마다 제작합니다. 색상은 수급 가능 여부를 확인해 안내합니다.',
  },
];
